import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "m8.248 16.752 2.648-6.178 1.323 1.324.883.883 1.324 1.323zM19.722 1.748l1.324 1.324-7.944 7.944-1.324-1.324zm3.53 3.53-7.944 7.944-1.324-1.324 7.944-7.944zm.882.883a1.25 1.25 0 0 0 0-1.765l-1.323-1.324-.883-.883L20.604.866a1.25 1.25 0 0 0-1.765 0l-8.826 8.826.006.005c-.11.111-.207.237-.27.385L7.1 16.259a1.248 1.248 0 0 0 1.64 1.64l6.177-2.647c.148-.064.274-.161.385-.271l.005.006z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M19.5 12.597V23c0 .69-.561 1.25-1.25 1.25h-15C2.561 24.25 2 23.69 2 23V5.5c0-.69.561-1.25 1.25-1.25h10.33L14.83 3H3.25a2.5 2.5 0 0 0-2.5 2.5V23a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V11.347z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }